module.exports = __webpack_public_path__ + "image-0a96fe2ee9b9.png";